import * as types from "./mutation-types";

export default {
  [types.SET_EDITEDSERVICE](state, payload) {
    state.editedService = payload;
  },
};
